import { Result } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const NotFoundResult = ({ title }: { title: string }) => {
  return <Result icon={<SearchOutlined />} title={title} />;
};
